export function stripHtml(html) {
    if (!html) return ''

    let text = html.replace(/<[^>]*>/g, '')

    text = text
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")

    text = text.replace(/\s+/g, ' ').trim()
    text = text.replace(/\|\|\|n\|\|\|/g, '')
    text = text.replace(/\r\n/g, "");
    text = text.trim()

    if (text.length > 160) {
        text = text.substring(0, 157) + '...'
    }

    return text
}